import { render, staticRenderFns } from "./CompanyUsers.vue?vue&type=template&id=1afe08d6"
import script from "./CompanyUsers.vue?vue&type=script&lang=js"
export * from "./CompanyUsers.vue?vue&type=script&lang=js"
import style0 from "./CompanyUsers.vue?vue&type=style&index=0&id=1afe08d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports